__turbopack_context__.v({
  "logoWrapper": "NavigationLogo-module-scss-module__axKgSG__logoWrapper",
  "siteLabel": "NavigationLogo-module-scss-module__axKgSG__siteLabel",
});
